import * as TYPES from '../types';

export const processingStatus = (state = {}, action) => {
  switch (action.type) {
    case TYPES.REPLACE_PROCESSING_STATUS_DATA:
      return { ...action.data };
    default:
      return state;
  }
};
